import React from 'react';
import { compose } from 'recompose';
import { withStyles } from 'material-ui';
import { injectIntl } from 'react-intl';
import PropTypes from 'prop-types';
import AppBar from 'material-ui/AppBar/AppBar';
import Tabs from 'material-ui/Tabs/Tabs';
import Tab from 'material-ui/Tabs/Tab';

import { COLORS } from '../../../constants/styles';
import materialStyles from './materialStyles';

export const TabsImpl = ({
  intl: { formatMessage },
  classes,
  activeTab,
  onTabSelect,
  tabList,
  renderContent,
  renderHeader,
  className,
  scrollable,
  scrollButtons,
}) => {
  const handleTabChange = (e, value) => {
    if (value !== activeTab) {
      onTabSelect(value);
    }
  };

  return (
    <div className={className}>
      <AppBar position="static" color="default" className={classes.appBar}>
        <Tabs
          indicatorColor={COLORS.bluePrimary}
          onChange={handleTabChange}
          value={activeTab}
          scrollable={scrollable}
          scrollButtons={scrollButtons}
        >
          {tabList.map(({ id, counter, label: tabLabel, tab: tabValue }) => {
            const text = formatMessage({ id: tabLabel });
            const label =
              typeof counter === 'number' ? `${text} (${counter})` : text;

            return (
              <Tab
                id={id}
                label={label}
                key={id}
                value={tabValue}
                classes={{
                  root: classes.root,
                  label: classes.label,
                  rootInheritSelected: classes.tabSelected,
                  labelContainer: classes.labelContainer,
                }}
              />
            );
          })}
        </Tabs>
        {renderHeader()}
      </AppBar>
      {renderContent(activeTab)}
    </div>
  );
};

const propTypes = {
  activeTab: PropTypes.string,
  tabList: PropTypes.array,
  renderContent: PropTypes.func,
  renderHeader: PropTypes.func,
  onTabSelect: PropTypes.func,
  scrollable: PropTypes.bool,
};

export const CommonTabs = compose(
  injectIntl,
  withStyles(materialStyles),
)(TabsImpl);

export const makeCustomTabs = styles =>
  compose(
    injectIntl,
    withStyles(styles),
  )(TabsImpl);

TabsImpl.propTypes = { ...propTypes };
TabsImpl.defaultProps = {
  tabList: [],
  renderContent: () => {},
  renderHeader: () => {},
  onTabSelect: () => {},
};
Tabs.propTypes = propTypes;



// WEBPACK FOOTER //
// ./src/components/common/CommonTabs/index.jsx